import { render, staticRenderFns } from "./BidderRegistration.vue?vue&type=template&id=604247a5&"
import script from "./BidderRegistration.vue?vue&type=script&lang=js&"
export * from "./BidderRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports